import { MainLoader, ResourceLoader } from 'ia-react-core';
import { Time } from 'omni-package-react-core';
import React, { FC } from 'react';
import { getHostName } from 'omni-package-react-cms';
import { NewsDetails } from '../../../interfaces/NewsDetails';
import NoDetails from './NoDetails';
import { StyledSafeHtml, StyledTile, StyledTime } from './Details.styles';
import { NewsDetailsResourceInfo } from '../../../components/NewsDetailsResource/NewsDetailsResource';

export interface DetailsProps {
  newsDetails: NewsDetails;
}

const Details: FC<DetailsProps> = ({ newsDetails }) => {
  if (!newsDetails) { return <NoDetails />; }
  if (newsDetails.Title === '' && newsDetails.Content === '') { return <NoDetails />; }
  const hostname = getHostName();
  let htmlContent = newsDetails.Content?.replace(/src="(?:\/cw\/)?-\/media\/(.*?)"/g, `src="${hostname}/cw/-/media/$1"`);
  htmlContent = htmlContent.replace(/href="(?:\/cw\/)?-\/media\/(.*?)"/g, `href="${hostname}/cw/-/media/$1"`);

  return (
    <ResourceLoader
      resourceSrc={NewsDetailsResourceInfo.name}
      CustomLoader={MainLoader}
    >

      <StyledTile data-testid="NewsDetailsTile" isDivided={false} title={newsDetails.Title}>
        <StyledTime>
          <Time time={new Date(newsDetails.ActivationDate)}></Time>
        </StyledTime>
        <StyledSafeHtml addTags={['img']} addAttr={['src']}>{htmlContent}</StyledSafeHtml>
      </StyledTile>
    </ResourceLoader>
  );
};

export default (Details);
